export const assetDisplayType = {
  GRID_SMALL: 0,
  GRID_BIG: 1
};
